import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { devConfig } from '../../config/config'; // Importing development configuration

/**
 * MyInfoBetShopView class extends JetView to create a specific view for user information in a betting shop.
 */
export default class MyInfoBetShopView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration
        const theme = this.app.config.theme; // Theme configuration
        const lenguages = [
            // Array of language options
            { id: 'ES', value: 'español (o castellano) (ES)' },
            { id: 'EN', value: 'English (EN)' },
        ];
        const main = {
            // Main information section configuration
            padding: 15,
            margin: 15,
            minWidth: 250,
            cols: [
                {
                    margin: 5,
                    rows: [
                        {
                            view: 'text', // Text input for user number
                            name: 'NumberUsername',
                            label: _('Número de usuario'),
                            labelPosition: 'top',
                            placeholder: _('Número de usuario'),
                            disabled: true, // Disabled input
                        },
                        {
                            view: 'text', // Text input for login access
                            name: 'LoginAccess',
                            label: _('Login para acceso'),
                            labelPosition: 'top',
                            placeholder: _('Login para acceso'),
                            disabled: true,
                        },
                        {
                            view: 'text', // Text input for last IP address
                            name: 'LastIPaddress',
                            label: _('Última dirección IP'),
                            labelPosition: 'top',
                            placeholder: _('Última dirección IP'),
                            disabled: true,
                        },
                        {
                            view: 'text', // Text input for last modified user
                            name: 'LastModifiedUser',
                            label: _('Último usuario modif'),
                            labelPosition: 'top',
                            placeholder: _('Último usuario modif'),
                            disabled: true,
                        },
                        {
                            view: 'richselect', // Dropdown for state selection
                            name: 'State',
                            localId: 'State:combo',
                            label: _('Estado'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'A', value: _('Active') },
                                { id: 'I', value: _('Inactive') },
                                { id: 'R', value: _('Retirado') },
                            ],
                            disabled: true,
                        },
                        {
                            view: 'richselect', // Dropdown for preferred language selection
                            name: 'PreferredLanguage',
                            localId: 'PreferredLanguage:combo',
                            label: _('Idioma preferido:'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: lenguages,
                            disabled: true,
                        },
                        {
                            view: 'text', // Text input for user name
                            name: 'UserName',
                            label: _('Nombre del usuario'),
                            labelPosition: 'top',
                            placeholder: _('Nombre del usuario'),
                            disabled: true,
                        },
                        {
                            view: 'richselect', // Dropdown for country selection
                            name: 'Country',
                            id: 'country',
                            localId: 'Country:combo',
                            label: _('País'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [],
                            disabled: true,
                        },
                        {
                            view: 'richselect', // Dropdown for currency selection
                            name: 'Currency',
                            id: 'currency',
                            localId: 'Currency:combo',
                            label: _('<span class=Moneda'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [],
                            disabled: true,
                        },
                        {
                            view: 'text', // Text input for creation date
                            name: 'CreationDate',
                            label: _('Fecha de creación'),
                            labelPosition: 'top',
                            placeholder: _('Fecha de creación'),
                            disabled: true,
                        },
                        {
                            view: 'text', // Text input for last entry date
                            name: 'LastEntryDate',
                            label: _('Fecha última entrada'),
                            labelPosition: 'top',
                            placeholder: _('Fecha última entrada'),
                            disabled: true,
                        },
                        {
                            view: 'text', // Text input for last modified date
                            name: 'LastDateModified',
                            label: _('Última Fecha modif'),
                            labelPosition: 'top',
                            placeholder: _('Última Fecha modif'),
                            disabled: true,
                        },
                    ],
                },
            ],
        };
        const options_main = {
            // Configuration for options section
            padding: 15,
            margin: 15,
            minWidth: 250,
            cols: [
                {
                    margin: 5,
                    rows: [
                        {
                            view: 'richselect', // Dropdown for special status selection
                            name: 'SpecialStatus',
                            localId: 'SpecialStatus:combo',
                            label: _('Estado especial'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'A', value: _('Active') },
                                { id: 'I', value: _('Inactive') },
                            ],
                            disabled: true,
                        },
                        {
                            view: 'richselect', // Dropdown for pin agent selection
                            name: 'Pinagent',
                            localId: 'Pinagent:combo',
                            label: _('Pinagent'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: '1', value: _('Si') },
                                { id: '2', value: _('No') },
                            ],
                            disabled: true,
                        },
                        {
                            view: 'richselect', // Dropdown for locked sales selection
                            name: 'Lockedsales',
                            localId: 'Lockedsales:combo',
                            label: _('Bloqueado para ventas'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: '1', value: _('Si') },
                                { id: '2', value: _('No') },
                            ],
                            disabled: true,
                        },
                        {
                            view: 'richselect', // Dropdown for print receipt box selection
                            name: 'PrintReceiptBox',
                            localId: 'PrintReceiptBox:combo',
                            label: _('Imprime recibo caja'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: '1', value: _('Si') },
                                { id: '2', value: _('No') },
                            ],
                            disabled: true,
                        },
                        {
                            view: 'richselect', // Dropdown for allows recharges selection
                            name: 'AllowsRecharges',
                            localId: 'AllowsRecharges:combo',
                            label: _('Permite recargas'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: '1', value: _('Si') },
                                { id: '2', value: _('No') },
                            ],
                            disabled: true,
                        },
                        {
                            view: 'richselect', // Dropdown for activate registration selection
                            name: 'ActivateRegistration',
                            localId: 'ActivateRegistration:combo',
                            label: _('Permite activar reg'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: '1', value: _('Si') },
                                { id: '2', value: _('No') },
                            ],
                            disabled: true,
                        },
                        {
                            view: 'text', // Text input for latitude
                            name: 'Latitud',
                            label: _('Latitud'),
                            labelPosition: 'top',
                            placeholder: _('Latitud'),
                            disabled: true,
                        },
                        {
                            view: 'text', // Text input for longitude
                            name: 'Longitud',
                            label: _('Longitud'),
                            labelPosition: 'top',
                            placeholder: _('Longitud'),
                            disabled: true,
                        },
                        {
                            view: 'text', // Text input for IP address
                            name: 'IP',
                            label: _('IP'),
                            labelPosition: 'top',
                            placeholder: _('IP'),
                            disabled: true,
                        },
                    ],
                },
            ],
        };
        const betshop_details = {
            // Configuration for betting shop details section
            padding: 15,
            margin: 15,
            minWidth: 250,
            cols: [
                {
                    margin: 5,
                    rows: [
                        {
                            view: 'text', // Text input for contact name
                            name: 'ContactName',
                            label: _('Nombre del contacto'),
                            labelPosition: 'top',
                            placeholder: _('Nombre del contacto'),
                            disabled: true,
                        },
                        {
                            view: 'text', // Text input for email
                            name: 'Email',
                            label: _('Correo electrónico'),
                            labelPosition: 'top',
                            placeholder: _('Correo electrónico'),
                            disabled: true,
                        },
                        {
                            view: 'text', // Text input for description
                            name: 'Description',
                            label: _('<spanDescripción'),
                            labelPosition: 'top',
                            placeholder: _('Descripción'),
                            disabled: true,
                        },
                        {
                            view: 'text', // Text input for phone number
                            name: 'Phone',
                            label: _('Teléfono'),
                            labelPosition: 'top',
                            placeholder: _('Teléfono'),
                            disabled: true,
                        },
                        {
                            view: 'richselect', // Dropdown for concessionaire selection
                            name: 'Concessionaire',
                            id: 'Concessionaire',
                            localId: 'Concessionaire:combo',
                            label: _('Concesionario'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [],
                            disabled: true,
                        },
                        {
                            view: 'richselect', // Dropdown for subconcessionaire selection
                            name: 'Subconcessionaire',
                            id: 'Subconcessionaire',
                            localId: 'Subconcessionaire:combo',
                            label: _('Subconcesionario'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [],
                            disabled: true,
                        },
                        {
                            view: 'richselect', // Dropdown for province/region selection
                            name: 'ProvinceRegion ',
                            id: 'ProvinceRegion',
                            localId: 'ProvinceRegion:combo',
                            label: _('Provincia/Región'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [],
                            disabled: true,
                        },
                        {
                            view: 'richselect', // Dropdown for city selection
                            name: 'City',
                            id: 'City',
                            localId: 'City:combo',
                            label: _('Ciudad'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [],
                            disabled: true,
                        },
                        {
                            view: 'text', // Text input for address
                            name: 'Address',
                            label: _('Dirección'),
                            labelPosition: 'top',
                            placeholder: _('Dirección'),
                            disabled: true,
                        },
                        {
                            view: 'text', // Text input for district
                            name: 'District',
                            label: _('Barrio'),
                            labelPosition: 'top',
                            placeholder: _('Barrio'),
                            disabled: true,
                        },
                        {
                            view: 'text', // Text input for phone number (duplicate)
                            name: 'Phone',
                            label: _('Teléfono'),
                            labelPosition: 'top',
                            placeholder: _('Teléfono'),
                            disabled: true,
                        },
                    ],
                },
            ],
        };
        const center_right = {
            // Configuration for center right section
            padding: 15,
            margin: 15,
            minWidth: 250,
            cols: [
                {
                    margin: 5,
                    rows: [
                        {
                            view: 'text', // Text input for daily quota reloads
                            name: 'DailyQuotaReloads',
                            label: _('Limite diario de recargas'),
                            labelPosition: 'top',
                            placeholder: _('Limite diario de recargas'),
                            disabled: true,
                        },
                        {
                            view: 'text', // Text input for commission reloads
                            name: 'CommissionReloads',
                            label: _('Comisión recargas'),
                            labelPosition: 'top',
                            placeholder: _('Comisión recargas'),
                            disabled: true,
                        },
                        {
                            view: 'text', // Text input for minimum bet
                            name: 'MinimumBet',
                            label: _('Apuesta mínima'),
                            labelPosition: 'top',
                            placeholder: _('Apuesta mínima'),
                            disabled: true,
                        },
                        {
                            view: 'text', // Text input for daily limit
                            name: 'DailyLimit',
                            label: _('Límite diario'),
                            labelPosition: 'top',
                            placeholder: _('Límite diario'),
                            disabled: true,
                        },
                    ],
                },
            ],
        };
        const right = {
            // Right section configuration (currently empty)
            margin: 5,
            rows: [],
        };
        const upper_section = {
            // Upper section configuration with accordions
            id: 'b5',
            rows: [
                {
                    collapsed: true,
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    margin: 15,
                    responsive: 'b5',
                    cols: [
                        {
                            multi: true,
                            view: 'accordion',
                            css: 'betShop',
                            collapsed: false,
                            paddingY: 10,
                            type: 'clean',
                            rows: [
                                {
                                    header: 'Datos Principales', // Main data header
                                    body: {
                                        rows: [main], // Main information section
                                    },
                                },
                            ],
                        },
                        {
                            multi: true,
                            view: 'accordion',
                            css: 'betShop',
                            collapsed: false,
                            paddingY: 10,
                            type: 'clean',
                            rows: [
                                {
                                    header: 'Datos Configuración', // Configuration data header
                                    body: {
                                        rows: [options_main], // Options main section
                                    },
                                },
                            ],
                        },
                        {
                            multi: true,
                            view: 'accordion',
                            css: 'betShop',
                            collapsed: false,
                            paddingY: 10,
                            type: 'clean',
                            rows: [
                                {
                                    header: 'Datos Punto de venta', // Betting shop data header
                                    body: {
                                        rows: [betshop_details], // Betting shop details section
                                    },
                                },
                            ],
                        },
                        {
                            multi: true,
                            view: 'accordion',
                            css: 'betShop',
                            collapsed: false,
                            paddingY: 10,
                            type: 'clean',
                            rows: [
                                {
                                    header: 'Configuración Punto de Venta', // Betting shop configuration header
                                    body: {
                                        rows: [center_right], // Center right section
                                    },
                                },
                            ],
                        },
                    ],
                },
            ],
        };
        const buttons = {
            // Button configuration section
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'),
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clears the form
                    },
                },
                {
                    view: 'button', // Save button
                    value: _('Guardar'),
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        if (this.getRoot().validate()) {
                            // Validates the form
                            const newdata = this.getRoot().getValues(); // Gets form values
                            this.app.callEvent('customer:save', [newdata]); // Calls save event
                            this.show('betShop'); // Navigates to betShop view
                        } else {
                            webix.message({
                                // Displays error message if validation fails
                                type: 'error',
                                text: 'Completa los campos...',
                            });
                        }
                    },
                },
            ],
        };
        webix.ui.fullScreen(); // Sets the UI to full screen
        return {
            // Returns the main form configuration
            view: 'form',
            id: 'formId',
            scroll: 'y',
            css: 'out',
            rows: [
                {
                    view: 'toolbar', // Toolbar at the top of the form
                    css: theme,
                    elements: [
                        {
                            view: 'label', // Label for the form title
                            label: _('Mi Información'),
                            width: 150,
                        },
                    ],
                },
                upper_section, // Upper section with accordions
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners and AJAX requests.
     * @param {Object} form - The form object to initialize.
     */
    init(form) {
        webix // AJAX request to get agent countries
            .ajax()
            .headers({
                'Content-type': 'application/json',
            })
            .post(devConfig.geturlApi() + 'Agent/GetAgentCountries', '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Error message on failure
                },
                success: function (text, data, XmlHttpRequest) {
                    var data = JSON.parse(
                        text
                            .replace(/"Id"/g, '"id"') // Normalizes JSON keys
                            .replace(/"Name"/g, '"value"'),
                    );
                    var optionsProvinceRegions = $$('country').getList(); // Gets country dropdown list
                    optionsProvinceRegions.clearAll(); // Clears existing options
                    optionsProvinceRegions.parse(data.Data); // Parses new options
                },
            });
        webix // AJAX request to get agents with two levels
            .ajax()
            .headers({
                'Content-type': 'application/json',
            })
            .post(devConfig.geturlApi() + 'Agent/GetAgentsTwoLevels?isList=1', '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Error message on failure
                },
                success: function (text, data, XmlHttpRequest) {
                    var data = JSON.parse(
                        text
                            .replace(/"UserName"/g, '"id"') // Normalizes JSON keys
                            .replace(/"Name"/g, '"value"'),
                    );
                    console.log(data.Data.Children); // Logs the children data
                    var options = $$('Concessionaire').getList(); // Gets concessionaire dropdown list
                    options.clearAll(); // Clears existing options
                    options.parse(data.Data.Children); // Parses new options
                },
            });
        this.app.callEvent('form:update', [this.getParam('user', true)]); // Calls update event with user parameter
        this.on(
            this.app,
            'customer:updatedata',
            (
                person, // Event listener for customer data update
            ) => form.setValues(person),
        );
        this.on(
            this.app,
            'person:select',
            (
                person, // Event listener for person selection
            ) => form.setValues(person),
        );
        $$('country').attachEvent('onChange', function (newv, oldv) {
            // Event listener for country change
            var optionscountries = this.getList().getItem(newv); // Gets selected country options
            var optionscurrencies = $$('currency').getList(); // Gets currency dropdown list
            optionscurrencies.clearAll(); // Clears existing options
            optionscurrencies.parse(optionscountries.currencies); // Parses new currency options
            var optionsProvinceRegions = $$('ProvinceRegion').getList(); // Gets province/region dropdown list
            optionsProvinceRegions.clearAll(); // Clears existing options
            optionsProvinceRegions.parse(optionscountries.departments); // Parses new province/region options
            webix.message('Value changed from: ' + oldv + ' to: ' + newv); // Logs value change
        });
        $$('ProvinceRegion').attachEvent('onChange', function (newv, oldv) {
            // Event listener for province/region change
            var optionsProvinceRegions = this.getList().getItem(newv); // Gets selected province/region options
            var optionsCity = $$('City').getList(); // Gets city dropdown list
            optionsCity.clearAll(); // Clears existing options
            optionsCity.parse(optionsProvinceRegions.cities); // Parses new city options
        });
        $$('Concessionaire').attachEvent('onChange', function (newv, oldv) {
            // Event listener for concessionaire change
            var optionsProvinceRegions = this.getList().getItem(newv); // Gets selected concessionaire options
            var optionsCity = $$('Subconcessionaire').getList(); // Gets subconcessionaire dropdown list
            optionsCity.clearAll(); // Clears existing options
            optionsCity.parse(optionsProvinceRegions.Children); // Parses new subconcessionaire options
        });
    }

    /**
     * Retrieves localized options for combo boxes and updates their lists.
     */
    getLocalizedComboOptions() {
        const _ = this.app.getService('locale')._; // Localization service
        let p_options = webix.copy(getPositions()); // Copies position options
        p_options.map((x) => (x.value = _(x.value))); // Localizes position values
        this.$$('position:combo').getPopup().getList().parse(p_options); // Updates position combo list
        let t_options = webix.copy(getTags()); // Copies tag options
        t_options.map((x) => (x.value = _(x.value))); // Localizes tag values
        this.$$('tags:combo').getPopup().getList().parse(t_options); // Updates tags combo list
        let c_options = webix.copy(getCities()); // Copies city options
        c_options.map((x) => (x.value = _(x.value))); // Localizes city values
        this.$$('cities:combo').getPopup().getList().parse(c_options); // Updates cities combo list
    }
}

// FILE DOCUMENTED
